export default __webpack_public_path__ + "static/Cali-activate-89ea342a1ddd66518d9bdf1ac492260c.svg";